var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "support-page" },
    [
      _c("p", { staticClass: "support-lead" }, [
        _vm._v(_vm._s(_vm.$t("support.subtitle"))),
      ]),
      _c(
        "div",
        { staticClass: "support-grid" },
        [
          _c(
            "hb-section",
            { attrs: { title: _vm.$t("support.channels_title") } },
            [
              _c(
                "ul",
                { staticClass: "support-channels" },
                _vm._l(_vm.channels, function (channel) {
                  return _c(
                    "li",
                    { key: channel.email, staticClass: "support-channel" },
                    [
                      _c("feather-icon", {
                        staticClass: "support-channel__icon",
                        attrs: { icon: channel.icon },
                      }),
                      _c("div", { staticClass: "support-channel__body" }, [
                        _c("span", { staticClass: "support-channel__label" }, [
                          _vm._v(_vm._s(channel.label)),
                        ]),
                        _c(
                          "a",
                          {
                            staticClass: "support-channel__value",
                            attrs: { href: channel.href },
                          },
                          [_vm._v(_vm._s(channel.email))]
                        ),
                        _c("small", { staticClass: "support-channel__hint" }, [
                          _vm._v(_vm._s(channel.hint)),
                        ]),
                      ]),
                    ],
                    1
                  )
                }),
                0
              ),
              _c(
                "p",
                { staticClass: "support-hours" },
                [
                  _c("feather-icon", {
                    staticClass: "mr-1 align-middle",
                    attrs: { icon: "ClockIcon" },
                  }),
                  _vm._v(" " + _vm._s(_vm.$t("support.hours")) + " "),
                ],
                1
              ),
            ]
          ),
          _c(
            "hb-section",
            {
              attrs: {
                title: _vm.$t("support.before_title"),
                subtitle: _vm.$t("support.before_subtitle"),
              },
            },
            [
              _c(
                "ol",
                { staticClass: "support-checklist" },
                _vm._l(_vm.checklist, function (step, index) {
                  return _c("li", { key: index }, [_vm._v(_vm._s(step))])
                }),
                0
              ),
              _c("div", { staticClass: "support-context" }, [
                _c(
                  "div",
                  { staticClass: "support-context__head" },
                  [
                    _c("span", { staticClass: "support-context__title" }, [
                      _vm._v(_vm._s(_vm.$t("support.context_title"))),
                    ]),
                    _c("hb-copy-button", {
                      attrs: { text: _vm.contextText, "allow-share": false },
                    }),
                  ],
                  1
                ),
                _c(
                  "dl",
                  { staticClass: "support-context__list" },
                  _vm._l(_vm.contextRows, function (row) {
                    return _c(
                      "div",
                      { key: row.label, staticClass: "support-context__row" },
                      [
                        _c("dt", [_vm._v(_vm._s(row.label))]),
                        _c("dd", [_vm._v(_vm._s(row.value))]),
                      ]
                    )
                  }),
                  0
                ),
              ]),
            ]
          ),
        ],
        1
      ),
      _c(
        "hb-section",
        { staticClass: "mt-4", attrs: { title: _vm.$t("support.faq_title") } },
        [
          _c(
            "div",
            { staticClass: "support-faq" },
            _vm._l(_vm.faq, function (item, index) {
              return _c(
                "details",
                { key: index, staticClass: "support-faq__item" },
                [
                  _c("summary", { staticClass: "support-faq__question" }, [
                    _vm._v(_vm._s(item.q)),
                  ]),
                  _c("p", { staticClass: "support-faq__answer" }, [
                    _vm._v(_vm._s(item.a)),
                  ]),
                ]
              )
            }),
            0
          ),
        ]
      ),
      _c(
        "hb-section",
        {
          staticClass: "mt-4",
          attrs: {
            title: _vm.$t("support.legal_title"),
            subtitle: _vm.$t("support.legal_subtitle"),
          },
        },
        [
          _c(
            "div",
            { staticClass: "support-links" },
            [
              _vm._l(_vm.legalLinks, function (link) {
                return _c(
                  "router-link",
                  {
                    key: link.to,
                    staticClass: "support-link",
                    attrs: { to: link.to },
                  },
                  [
                    _c("feather-icon", {
                      staticClass: "mr-1",
                      attrs: { icon: "FileTextIcon" },
                    }),
                    _vm._v(" " + _vm._s(link.label) + " "),
                  ],
                  1
                )
              }),
              _c(
                "button",
                {
                  staticClass: "support-link",
                  attrs: { type: "button" },
                  on: { click: _vm.openCookiePreferences },
                },
                [
                  _c("feather-icon", {
                    staticClass: "mr-1",
                    attrs: { icon: "SlidersIcon" },
                  }),
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("support.link_cookie_preferences")) +
                      " "
                  ),
                ],
                1
              ),
            ],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }